import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const muniMappingcolumns: GridColumnConfig[] = [
  // {
  //   title: 'CoC Sort Order',
  //   field: 'muncipalityServiceSortOrder',
  //   filter: 'text',
  //   editable: true,
  //   editor: 'numeric',
  //   width: '150',
  //   searchable: true,
  // },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
    // editable: true,
  },
  {
    title: 'Predecessor',
    field: 'predecessorNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Options',
    field: 'options',
    filter: 'text',
    searchable: true,
    width: '150px',
  },
  // {
  //   title: 'Price ($)',
  //   field: 'price',
  //   filter: 'numeric',
  //   fieldType: 'currency',
  //   searchable: true,
  // },
  // {
  //   title: 'Cut-off Time',
  //   field: 'cutOffTime',
  //   filter: 'text',
  //   searchable: true,
  // },
  // {
  //   title: 'Inspection Required',
  //   field: 'inspectionRequired',
  //   filter: 'text',
  //   searchable: true,
  // }
];
